import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { ModuleLoadingService } from '@rpgc-ai/services/loading/module-loading.service';

import { TranslocoService } from '@jsverse/transloco';

/**
 * Progress bar pinned to the top edge of the viewport while a lazy module is loading.
 *
 * The host element is always in the DOM and switches state through `data-visible`: an element that
 * appears and disappears could not fade, and the server and the client would render different trees.
 * The safe-area utilities sit on the host because the bar hugs the very top of the screen, where
 * the Telegram chrome and the notch live.
 */
@Component({
  selector: 'app-module-loading-bar',
  styleUrl: './module-loading-bar.component.scss',
  templateUrl: './module-loading-bar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'tma:top-safe-0 mobile:top-safe-0',
    '[attr.data-visible]': 'isBarVisible()',
    '[attr.aria-hidden]': "isBarVisible() ? null : 'true'",
    '[attr.role]': "isBarVisible() ? 'progressbar' : null",
    '[attr.aria-label]': 'isBarVisible() ? loadingLabel() : null',
  },
})
export class ModuleLoadingBarComponent {
  readonly #moduleLoadingService = inject(ModuleLoadingService);
  readonly #translocoService = inject(TranslocoService);

  readonly isBarVisible = this.#moduleLoadingService.isBarVisible;
  readonly loadingLabel = toSignal(this.#translocoService.selectTranslate<string>('COMMON.LOADING'), { initialValue: '' });
}
